import { useState, useEffect, useCallback } from 'react';

const SCRIPT_ID = 'recaptcha-v3-script';
let loadPromise = null;

function loadRecaptchaScript(siteKey) {
  if (loadPromise) return loadPromise;
  const existing = document.getElementById(SCRIPT_ID);
  if (existing) {
    loadPromise = Promise.resolve();
    return loadPromise;
  }
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return loadPromise;
}

export function useRecaptcha() {
  const [siteKey, setSiteKey] = useState(null);
  const [enabled, setEnabled] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    fetch(`${API_URL}/api/system/captcha/public-key`)
      .then(r => r.json())
      .then(data => {
        setEnabled(data.enabled);
        setSiteKey(data.site_key);
        if (data.enabled && data.site_key) {
          loadRecaptchaScript(data.site_key).then(() => setReady(true));
        }
      })
      .catch(() => {});
  }, []);

  const getToken = useCallback(async (action) => {
    if (!enabled || !ready || !siteKey || !window.grecaptcha) return null;
    try {
      await new Promise(resolve => window.grecaptcha.ready(resolve));
      return await window.grecaptcha.execute(siteKey, { action });
    } catch {
      return null;
    }
  }, [enabled, ready, siteKey]);

  return { enabled, ready, getToken };
}
